import { render, staticRenderFns } from "./DeathModal.vue?vue&type=template&id=aecf6e2c&"
import script from "./DeathModal.vue?vue&type=script&lang=js&"
export * from "./DeathModal.vue?vue&type=script&lang=js&"
import style0 from "./DeathModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeathModal.vue"
export default component.exports